<template>
  <div class=""></div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  async created() {
    // await this.loadEruda();
    await this.ZaloWebAuth();
  },
  mounted() {},
  methods: {
    loadEruda() {
      // 检查是否已加载
      if (window.eruda) {
        console.log("Eruda 已加载");
        return;
      }

      // 创建 script 元素
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/eruda";
      script.async = true;

      // 添加到文档头部
      document.head.appendChild(script);

      console.log("开始加载 Eruda...");

      // 监听加载完成事件
      script.onload = () => {
        console.log("Eruda 加载完成");

        // 初始化 Eruda
        eruda.init({
          tool: [
            "console",
            "elements",
            "network",
            "resources",
            "info",
            "snippets",
          ],
        });

        // 可选：自动显示或隐藏 Eruda 面板
        eruda.show(); // 自动显示
        // eruda.hide(); // 自动隐藏
      };

      script.onerror = (error) => {
        console.error("Eruda 加载失败:", error);
      };
    },

    ZaloWebAuth() {
      let webUUID = this.$store.state.webUUID || Adjust.getWebUUID();
      let params = {
        game_id: new URLSearchParams(window.location.search).get("game_id"),
        device_id: webUUID,
        third_platform: 3,
        code: new URLSearchParams(window.location.search).get("code"),
        code_verifier: new URLSearchParams(window.location.search).get(
          "codeVerifier"
        ),
      };
      this.$http.post("/apis/h5/thirdLogin", params).then((res) => {
        console.log(res);
        if (res.code === 200) {
          switch (Number(params.game_id)) {
            case 14:
              Adjust.trackEvent({
                eventToken: "3s39it",
              });
              break;
            case 15:
              Adjust.trackEvent({
                eventToken: "mjjqh8",
              });
              break;
            default:
              break;
          }
          if (res.data.isReg !== "0") {
            switch (Number(params.game_id)) {
              case 14:
                Adjust.trackEvent({
                  eventToken: "dz32s3",
                });
                Adjust.trackEvent({
                  eventToken: "ilhflt",
                });
                break;
              case 15:
                Adjust.trackEvent({
                  eventToken: "l049mw",
                });
                Adjust.trackEvent({
                  eventToken: "5taqik",
                });
                break;
              default:
                break;
            }
          }
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userid", res.data.userid);
          localStorage.setItem("iframeURL", res.data.login_url);
          localStorage.removeItem("guestInfo");
          this.$store.state.token = res.data.token;
          this.$store.state.iframeURL = res.data.login_url;
          // this.$router.push("/main");
          this.$router.push("/main/my");
          this.$store.state.sdkShow = false;
          this.$store.commit("openSdk", false);
        } else {
          this.$router.push({
            path: "/login",
            query: { game_id: localStorage.getItem("game_id") },
          });
          this.$Msg(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
